import { useEffect, useState } from 'react'
import axios from 'axios'
import { baseUrl } from '../config/config'

export const useGetContacts = () => {
   const [data, setData] = useState([])
   const [isLoading, setIsLoading] = useState(true)
   useEffect(() => {
      axios
         .get(`${baseUrl}/info/contact`)
         .then((response) => {
            const data = response.data
            setData(data)
            setIsLoading(false)
         })
         .catch((error) => {
            console.error('Произошла ошибка:', error)
            setIsLoading(false)
         })
   }, [])
   return { data, isLoading }
}
